import { Heading, Section, Stack } from "@carbon/react";
import { FormProvider, UseFormReturn } from "react-hook-form";

import { TextAreaFormField } from "src/components/Form/TextAreaFormField";
import { TextInputFormField } from "src/components/Form/TextInputFormField";
import { useT } from "src/internationalization";
import { cn } from "src/utils/string.utils";

import { DetailsFormData } from "./CreateRuleModal";

type CreateRuleModalStep2Props = {
  hidden: boolean;
  methods: UseFormReturn<DetailsFormData>;
};

export const CreateRuleModalStep2: React.FC<CreateRuleModalStep2Props> = ({ hidden, methods }) => {
  const t = useT();

  return (
    <div
      className={cn("flex flex-col h-full px-5", {
        hidden: hidden,
      })}
    >
      <FormProvider {...methods}>
        <Stack gap={6} className="mb-4">
          <Section level={3}>
            <Heading className="ml-0">
              {t("page.rules.modal.create.form.group.details.legend")}
            </Heading>
          </Section>
          <TextInputFormField
            id="name"
            name="name"
            control={methods.control}
            label={t("general.form.name.label")}
            helperText={t("page.rules.modal.create.form.name.helper")}
          />
          <TextInputFormField
            id="code"
            name="code"
            control={methods.control}
            label={t("general.form.code.label")}
            helperText={t("page.rules.modal.create.form.code.helper")}
          />
          <TextAreaFormField
            id="description"
            label={t("general.form.description.label")}
            helperText={t("page.rules.modal.create.form.description.helper")}
            name="description"
            control={methods.control}
          />
        </Stack>
      </FormProvider>
    </div>
  );
};
